import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  get,
  noop,
} from 'lodash';
import {
  compose,
  setDisplayName,
} from 'recompose';
import {
  Nav,
  NavbarToggler,
} from 'reactstrap';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import PaymentInfoButton from 'routes/Payments/PaymentInfoButton';
import { Avatar, injectIntl } from 'components';
import { getFullNameOrEmail, toCurrency, updatedClassname } from 'helpers/utils';
import { markNotificationAsRead } from 'redux/notifications/actions';
import { loginOrganization } from 'redux/auth/actions';
import {
  getDataSelector,
  getSelector,
} from 'redux/selectors';
import {
  setHotNotification,
  setLocale,
  setSidebarOpen,
} from 'redux/ui/actions';
import { isMobile } from 'helpers/detect-mobile';
import { Link } from 'react-router-dom';
import {
  clearCartLocalStorage,
} from 'helpers/utils';

export class Header extends Component {
  static contextTypes = {
    brands: PropTypes.shape({}),
    currentUser: PropTypes.shape({}),
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
    isConsumer: PropTypes.bool,
    isMember: PropTypes.bool,
    payOnline: PropTypes.bool,
  };

  static propTypes = {
    headerTitle: PropTypes.node,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    orderCart: PropTypes.node,
    searchContent: PropTypes.node,
    organizations: PropTypes.arrayOf(PropTypes.shape({})),
    account: PropTypes.shape({}),
    formatMessage: PropTypes.func.isRequired,
    setSidebarOpen: PropTypes.func.isRequired,
    loginOrganization: PropTypes.func.isRequired,
    filterCategory: PropTypes.node,
  };

  static defaultProps = {
    headerTitle: '',
    history: {},
    orderCart: null,
    searchContent: '',
    organizations: [],
    account: {},
    filterCategory: null,
  };

  asideToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  sidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle('brand-minimized');
    document.body.classList.toggle('sidebar-minimized');
  }

  handleAvatarClick = (memberId) => {
    const {
      account,
      organizations,
      history,
    } = this.props;
    const currentRoleId = get(organizations[0], 'account.currentRoleId');
    const role = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[currentRoleId] || 'Personal';
    const { account: { email } } = organizations[0];
    if (email !== account.email) {
      this.props.loginOrganization({
        memberId,
        onSuccess: () => {
          if (role !== 'Personal') {
            history.push('/track-orders');
          } else {
            history.push('/settings');
          }
          window.location.reload();
        },
      });
    } else if (email === account.email && role !== 'Personal') {
      if (role === 'Consumer') {
        history.push('/settings');
      } else {
        history.push('/track-orders');
      }
    } else if (email === account.email && role === 'Personal') {
      history.push('/settings');
    }
  };

  activeRoute = (routeName) => {
    const { location: { pathname } } = this.props;
    return pathname.indexOf(routeName) > -1;
  }

  handleLogout = () => {
    memoryDB.tokenInfo = JSON.stringify({ data: {} });
    clearCartLocalStorage();
    window.location = '/';
  };

  renderNotificationItem = (notification) => {
    switch (notification.action) {
      case 'signup': {
        const { email, name, company } = notification.changeData || {};
        return (
          <ListItem key={notification.id}>
            <ListItemText primary={`New sign-up ${name ? `by ${name} ` : ''}with ${email}${company ? ` as "${company}"` : ''}`} />
          </ListItem>
        );
      }
      default:
        break;
    }
    return null;
  }

  render() {
    const { brands, currentUser, isMember, payOnline, isConsumer } = this.context;
    const {
      headerTitle,
      history,
      orderCart,
      searchContent,
      formatMessage,
      setSidebarOpen,
      organizations,
      account,
      filterCategory
    } = this.props;
    const isOrderPage = history.location.pathname === '/order';
    const fullNameOrEmail = getFullNameOrEmail(currentUser.account);
    const role = get(currentUser, 'role.name') || 'Personal';
    const balance = get(currentUser, 'account.creditBalance');
    const creditPending = get(currentUser, 'account.creditPending');
    const creditUsable = get(currentUser, 'account.creditUsable');
    const { id, account: { email, profile: { companyName, logoUrl } } } = organizations[0];
    const clickable = true;
    return (
      <header
        className="app-header navbar"
        style={{
          backgroundColor: brands.navbarColor,
          color: brands.navTextColor || 'white',
        }}
      >
        {(!isConsumer || (isConsumer && isMobile)) && (
          <NavbarToggler onClick={() => setSidebarOpen(true)}>
            <MenuIcon style={{ fill: '#4695ec', fontSize: 30 }} />
          </NavbarToggler>
        )}
        {!isConsumer && (
          <Nav navbar>
            <h3 className="header-title">{headerTitle}</h3>
          </Nav>
        )}
        {!isConsumer && searchContent}
        {!isConsumer && (
          <div className="user-name">
            <div style={{
              opacity: 0.6,
              fontSize: '0.675rem',
              textAlign: 'right',
            }}
            >
              {formatMessage(role)}&nbsp;&nbsp;
            </div>
            {fullNameOrEmail}
          </div>
        )}
        <div className="order-cart" style={isConsumer ? {marginLeft:'70px'} : {}}>
          {orderCart}
        </div>
        {role !== 'Personal' && (
          <div
            className={`credit-balance ${updatedClassname(this, 'balance', balance)}`}
            onClick={isMember ? noop : () => history.push('/payments')}
            style={{ display: 'none' }}
          >
            {payOnline && (
              <div className="d-flex justify-content-between">
                <span className="d-sm-down-none">{formatMessage('Available')}</span>
                <span className="d-md-up-none">A</span>
                <strong>&nbsp;{toCurrency(balance)}</strong>
              </div>
            )}
            {payOnline && (
              <div className="d-flex justify-content-between">
                <span className="d-sm-down-none">{formatMessage('Pending')}</span>
                <span className="d-md-up-none">P</span>
                <strong>&nbsp;{toCurrency(creditPending)}</strong>
              </div>
            )}
            <div className="d-flex justify-content-between">
              <span className="d-sm-down-none">{payOnline ? formatMessage('Usable') : formatMessage('Balance')}</span>
              <span className="d-md-up-none">U</span>
              <strong style={{ color: creditUsable < 0 ? 'red' : 'white' }}>&nbsp;{toCurrency(creditUsable)}</strong>
            </div>
          </div>
        )}
        <div className="header-nav-right">
          {isMobile && filterCategory}
          <div className={`nav-avatar `}>
            {organizations[0] && (
              <Avatar
                highlighted
                clickable={clickable}
                src={logoUrl}
                key={email}
                fullName={companyName || email}
                onClick={() => this.handleAvatarClick(id)}
              />
            )}
          </div>
        </div>
        <Nav navbar>
          {/* <IconButton
            aria-label={`${notifications.unreadCount || 0} pending messages`}
            buttonRef={(el) => { this.popoverEl = el; }}
            className={classes.messages}
            onClick={this.openNotificationPopover}
          >
            {notifications.unreadCount ?
              <Badge
                badgeContent={notifications.unreadCount || 0}
                color="secondary"
              >
                <MailIcon style={{ color: 'white' }} />
              </Badge>
            :
              <MailIcon style={{ color: 'white' }} />
            }
          </IconButton>
          <Popover
            anchorEl={this.popoverEl}
            anchorOrigin={{
              horizontal: 'right',
              vertical: 'bottom',
            }}
            anchorReference="anchorEl"
            onClose={this.closeNotificationPopover}
            open={notificationPopoverOpen}
            transformOrigin={{
              horizontal: 'right',
              vertical: 'top',
            }}
          >
            <List>
              {notifications.notifications && notifications.notifications.length > 0 ?
                notifications.notifications.map(this.renderNotificationItem)
              : (
                <ListItem>
                  <ListItemText primary={formatMessage('No notifications')} />
                </ListItem>
              )}
            </List>
          </Popover>
          <HelperIcon helpContent={helpContent} /> */}
        </Nav>
      </header>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  headerTitle: getSelector('ui', 'headerTitle')(state),
  helpContent: getSelector('ui', 'helpContent')(state),
  notifications: getDataSelector('notifications', 'app')(state).toJS(),
  orderCart: getSelector('ui', 'orderCart')(state),
  searchContent: getSelector('ui', 'searchContent')(state),
  filterCategory: getSelector('ui', 'filterCategory')(state),

});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  markAsRead: id => dispatch(markNotificationAsRead(id)),
  setHotNotification: payload => dispatch(setHotNotification(payload)),
  setLocale: payload => dispatch(setLocale(payload)),
  setSidebarOpen: open => dispatch(setSidebarOpen(open)),
  loginOrganization: payload => dispatch(loginOrganization(payload)),
});

export default compose(
  setDisplayName('Header'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  injectIntl,
  // withStyles(styles),
)(Header);
